import React, { useState, useEffect } from 'react'
import { string, func, bool } from 'prop-types'

import TextInputField from 'Pods/Shared/TextInputField'
import Icon from 'Pods/Shared/Icon/Icon'

const name = 'query'

function QueryField({ query = '', search, isDisabled = false }) {
  const [currentQuery, setCurrentQuery] = useState(query)

  useEffect(() => {
    setCurrentQuery(query)
  }, [query])

  return (
    <form
      className="search-form"
      onSubmit={(e) => {
        e.preventDefault()
        search(name, currentQuery)
      }}
    >
      <TextInputField
        id="purchases_query_input"
        type="text"
        name={name}
        placeholder="Search by Keywords"
        className="form-control"
        text={currentQuery}
        onChange={(e) => { setCurrentQuery(e.target.value) }}
        disabled={isDisabled}
      />
      <button
        type="submit"
        className="btn btn-transparent"
        disabled={isDisabled}
      >
        <Icon
          type="search"
          color="green-dark"
          className="info-icon"
          notSpaced
        />
      </button>
    </form>
  )
}

QueryField.propTypes = {
  query: string,
  search: func.isRequired,
  isDisabled: bool,
}

export default QueryField
